export { default } from './InterestCredit';
